import http from '../../utils/http';
const rootUrl = '/api';

const creditCard = {
	/**
	 * 绑定信用卡
	 * @returns
	 */
	addPayCard(data) {
		return http.post( `${rootUrl}/addPayCard`, data, { errCode: '@shining3d/xl-design-order.apiErr.creditCard' });
	},
    /**
	 * 获取信用卡列表
	 * @returns
	 */
	getPayCard(params) {
		return http.get( `${rootUrl}/getPayCard`, params, { errCode: '@shining3d/xl-design-order.apiErr.creditCard' });
	},
    /**
	 * 删除信用卡
	 * @returns
	 */
	delPayCard(data) {
		return http.post( `${rootUrl}/gelPayCard`, data, { errCode: '@shining3d/xl-design-order.apiErr.creditCard' });
	},
    /**
	 * 信用卡设为默认
	 * @returns
	 */
	setDefaultPayCard(data) {
		return http.post( `${rootUrl}/setDefaultPayCard`, data, { errCode: '@shining3d/xl-design-order.apiErr.creditCard' });
	},
    /**
	 * 添加账单联系人
	 * @returns
	 */
	addBillContact(data) {
		return http.post( `${rootUrl}/addBillContact`, data, { errCode: '@shining3d/xl-design-order.apiErr.creditCard' });
	},
    /**
	 * 删除账单联系人
	 * @returns
	 */
	delBillContact(data) {
		return http.post( `${rootUrl}/delBillContact`, data, { errCode: '@shining3d/xl-design-order.apiErr.creditCard' });
	},
    /**
	 * 获取账单联系人
	 * @returns
	 */
	getBillContact(params) {
		return http.get( `${rootUrl}/getBillContact`, params, { errCode: '@shining3d/xl-design-order.apiErr.creditCard' });
	},
    /**
	 * 编辑账单联系人
	 * @returns
	 */
	updateBillContact(data) {
		return http.post( `${rootUrl}/updateBillContact`, data, { errCode: '@shining3d/xl-design-order.apiErr.creditCard' });
	},
    /**
	 * 卡支付
	 * @returns
	 */
	payWithCard(data) {
		return http.post( `${rootUrl}/payWithCard`, data, { errCode: 'payWithCard' });
	},
    /**
	 * 再次请求支付
	 * @returns
	 */
	continuePayWithCard(data) {
		return http.post( `${rootUrl}/continuePayWithCard`, data, { errCode: '@shining3d/xl-design-order.apiErr.creditCard' });
	},
    /**
	 * 获取洲/国家/省/市/区县
	 * @returns
	 */
    getArea(params) {
		return http.get( `${rootUrl}/getArea`, params, { errCode: '@shining3d/xl-design-order.apiErr.creditCard' });
	},
	/**
	 * 第三方支付完成后，查询结算状态和更新结算状态
	 * @returns
	 */
	paySuccess(data) {
		return http.post( `${rootUrl}/paySuccess`, data, { errCode: '@shining3d/xl-design-order.apiErr.creditCard' });
	},
	/**
	 * 支付记录
	 * @returns
	 */
    getPaymentList(params) {
		return http.get( `${rootUrl}/getPaymentList`, params, { errCode: '@shining3d/xl-design-order.apiErr.creditCard' });
	},
	/**
	 * 导出支付记录
	 * @returns
	 */
    exportPaymentList(params) {
		return http.get( `${rootUrl}/exportPaymentList`, params, { errCode: '@shining3d/xl-design-order.apiErr.creditCard' });
	},
	/**
	 * 获取积分详情
	 */
	factoryPointCardList(params) {
		return http.get( `${rootUrl}/factoryPointCardList`, params, { errCode: '@shining3d/xl-design-order.apiErr.factoryPointCardList' });
	},
	/**
	 *  获取先临积分
	 */
	getPoint( params ) {
		return http.get( `${rootUrl}/getPoint`, params, { errCode: 'getPoint' });
	}
};
export default creditCard;
